import DOMPurify from "dompurify";
import {useFormContext} from "react-hook-form";

import Button from "@/components/button/Button.tsx";
import {IDPInfo} from "@/lib/types/statuspages.ts";

interface IDPInfoProps {
  info: IDPInfo;
  className?: string;
}

export const IDPTestBlock = ({className, info}: IDPInfoProps) => {
  const {setValue} = useFormContext();
  const populateForm = () => {
    setValue("idp_certificate", info.idp_certificate);
    setValue("idp_entity_id", info.idp_entity_id);
    setValue("idp_sso_target_url", info.idp_sso_target_url);
  };
  return (
    <div className={className}>
      <h6 className="mt-4 mb-1">{info.name}</h6>
      {info.info && <small dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(info.info)}} />}
      <Button variant={"secondary"} className="mt-2 w-100" onClick={populateForm}>
        Populate Form
      </Button>
    </div>
  );
};
